/* global module */

/**
 * RESTful API Services                                                                                           RESTful API Services
 * ************************************************************************************************************************************
 */
const angular = require('angular');
const moment = require('moment');
var ngResource = require('angular-resource');
var app = angular.module('learn-resources', ['ngResource']);

require('./resources/access-profile');
require('./resources/admin-assignments');
require('./resources/admin-content');
require('./resources/admin-users');
require('./resources/analyze');
require('./resources/analyze-managers');
require('./resources/api-applications');
require('./resources/articles');
require('./resources/assessments');
require('./resources/assessment-host');
require('./resources/assessment-scores');
require('./resources/assignments');
require('./resources/assignment-templates');
require('./resources/authorization-resource');
require('./resources/available-copy');
require('./resources/badges');
require('./resources/categories');
require('./resources/certificates');
require('./resources/companies');
require('./resources/company-integrations');
require('./resources/content');
require('./resources/content-integrations');
require('./resources/custom-copy');
require('./resources/data/reports');
require('./resources/dynamic-messages');
require('./resources/error-reporting');
require('./resources/events');
require('./resources/event-participation');
require('./resources/explorer');
require('./resources/files');
require('./resources/feedback');
require('./resources/google-calendar');
require('./resources/google-export');
require('./resources/google-general');
require('./resources/google-meets');
require('./resources/groups');
require('./resources/imported-content');
require('./resources/imported-content-registrations');
require('./resources/invitations');
require('./resources/journeys');
require('./resources/main-comments');
require('./resources/managers');
require('./resources/microsoft-teams');
require('./resources/multi-session-workshops');
require('./resources/notifications');
require('./resources/overview');
require('./resources/partners');
require('./resources/passcode');
require('./resources/partners');
require('./resources/polls');
require('./resources/presentations');
require('./resources/proliferation');
require('./resources/proliferation-new');
require('./resources/quizzes');
require('./resources/ratings');
require('./resources/register-with-userid');
require('./resources/registration-data');
require('./resources/reports');
require('./resources/s3-uploads');
require('./resources/saml');
require('./resources/scores');
require('./resources/scorm-content');
require('./resources/scorm-registrations');
require('./resources/scorm-view');
require('./resources/shares');
require('./resources/skills');
require('./resources/slack');
require('./resources/slack-integration');
require('./resources/suggestions');
require('./resources/surveys');
require('./resources/text-search');
require('./resources/tracks');
require('./resources/transcode');
require('./resources/users');
require('./resources/user-assessments');
require('./resources/user-journeys');
require('./resources/user-notifications');
require('./resources/user-tracks');
require('./resources/user-workshops');
require('./resources/videos');
require('./resources/viewables');
require('./resources/workflows');
require('./resources/workflow-results');
require('./resources/workshops');
require('./resources/workshop-instances');
require('./resources/zoom-integration');

/**
 * Browserify Module export
 * @type angular module @exp;app
 */
module.exports = app;
